"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genAppRequestConfig = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
var _internalUtils = require("./internalUtils");
var genAuthHeaders = function genAuthHeaders() {
  var headers = (0, _defineProperty2.default)({
    "Content-Type": _constants.CONTENT_TYPE_APPLICATION_JSON,
    Accept: _constants.CONTENT_TYPE_APPLICATION_JSON
  }, _constants.XSRF_HEADER, (0, _internalUtils.getSessionKey)());
  var sessionID = (0, _internalUtils.getSessionID)();
  if (sessionID) {
    headers["Smartsheet-sid"] = sessionID;
  }
  return headers;
};
var getUrlAction = function getUrlAction() {
  try {
    var jscDesktop = (0, _internalUtils.unsafeWindowObjectRetrieve)("jscDesktop");
    return jscDesktop.desktopType === _constants.DESKTOP_TYPE.UPDATE ? "update" : jscDesktop.desktopType === _constants.DESKTOP_TYPE.PUBLISH ? "publish" : jscDesktop.desktopType === _constants.DESKTOP_TYPE.EMBED ? "embed" : "home";
  } catch (e) {
    return "home";
  }
};
var genAppRequestParams = function genAppRequestParams(config) {
  var formAction = config.formAction,
    formName = config.formName,
    _config$timeout = config.timeout,
    timeout = _config$timeout === void 0 ? _constants.DEFAULT_CLIENT_TIMEOUT_MS : _config$timeout;
  return (0, _objectSpread2.default)({
    formName: formName,
    formAction: formAction,
    to: timeout,
    ss_v: (0, _internalUtils.getVersion)()
  }, (0, _internalUtils.genConditionalParams)([["publishKey", "pk"], ["embedData", "embedData"], ["updateTicket", "ux"]]));
};

/**
 * Generates an axios request configuration that's ready to send for an app request
 * @param config config object for the request
 * @param data data to send to the API
 */
var genAppRequestConfig = function genAppRequestConfig(config, data) {
  var _config$timeout2 = config.timeout,
    timeout = _config$timeout2 === void 0 ? _constants.DEFAULT_CLIENT_TIMEOUT_MS : _config$timeout2;
  var url = "/b/".concat(getUrlAction());
  var params = genAppRequestParams(config);
  var headers = genAuthHeaders();
  return {
    method: "POST",
    headers: headers,
    url: url,
    data: data !== null && data !== void 0 ? data : {},
    params: params,
    timeout: timeout
  };
};
exports.genAppRequestConfig = genAppRequestConfig;
//# sourceMappingURL=appRequest.js.map